import { UnitTemplateGroup } from '../../models/unit-template-groups.model';

export namespace UnitTemplateActions {
  export class Load {
    public static readonly type = '[UnitTemplate] Load Units Template';
  }

  export class LoadMore {
    public static readonly type = '[UnitTemplate] Load More Units Template';
  }

  export class Delete {
    public static readonly type = '[UnitTemplate] Delete Unit Template';
    constructor(public unitTemplateUuid: string) {}
  }

  export class Groups {
    public static readonly type = '[UnitTemplate] Load Unit Template Groups';
  }

  export class SetSelectedGroup {
    public static readonly type = '[UnitTemplate] Set Selected Unit Template Group';
    constructor(public selectedGroup: UnitTemplateGroup) {}
  }

  export class AddUnitTemplateGroup {
    public static readonly type = '[UnitTemplate] Add Unit Template Group';
    constructor(
      public name: string,
      public isOrganization: boolean
    ) {}
  }

  export class UpdateGroupTemplateName {
    public static readonly type = '[UnitTemplate] Update Unit Template Group Name';
    constructor(
      public groupId: string,
      public description: string
    ) {}
  }

  export class DeleteGroupTemplate {
    public static readonly type = '[UnitTemplate] Delete Unit Template Group';
    constructor(public groupId: string) {}
  }

  export class UpdateUnitDescription {
    public static readonly type = '[UnitTemplate] Update Unit Template Description';
    constructor(
      public unitTemplateId: string,
      public description: string
    ) {}
  }

  export class MoveUnit {
    public static readonly type = '[UnitTemplate] Move Unit to Group';
    constructor(
      public unitTemplateId: string,
      public groupId: string
    ) {}
  }

  export class Create {
    public static readonly type = '[UnitTemplate] Create Unit Template';
    constructor(
      public unitId: string,
      public unitTemplateName: string,
      public groupId: string,
      public alternativeId: string
    ) {}
  }

  export class ClearState {
    public static readonly type = '[UnitTemplate] Clear State';
  }
}
